import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewRef,
} from '@angular/core'
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgIf } from '@angular/common';
@Component({
    selector: 'gd-rvmulti',
    template: `
    <div [formGroup]="form" class="spacing">
      <!-- <span *ngIf="field.disabled == true"> -->
      <textarea
        [formControlName]="field.name"
        [id]="field.name"
        rows="7"
        [readOnly]="field.disabled"
        style=" width: 400px; height:100px; line-height:18px; background-color:#ffffff; color:#111827; -webkit-text-fill-color:#111827; border:1px solid #9ca3af; border-radius:4px;"
      ></textarea>
      <!-- </span> -->
      <!--  <span *ngIf="field.disabled == false">test
        <textarea
          [formControlName]="field.name"
          [id]="field.name"
          readOnly="false"
          rows="7"  
          [placeholder]="field.value"
          style=" width: 400px; height:100px; line-height:18px;"
        ></textarea>
      </span> -->
      <span style="padding-left: 20px"></span>
    </div>
    <div
      class="alert alert-danger my-1 p-2 fadeInDown animated fieldnot"
      style=" text-align: center;
  font-size:11px;"
      *ngIf="reptextval && field?.name === 'AlertRepText'"
    >
      Alert Rep Text is required.
    </div>
  `,
    styleUrls: ['./../../../pages/Transactions/atoms/globalform.css'],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgIf,
    ]
})
export class RvMulitLineComponent implements AfterViewInit {
  @Input() field: any = {}
  @Input() form: UntypedFormGroup
  @Input() btn: boolean
  @Output() pushForm = new EventEmitter<any>()
  public reptextval = false
  public myable = true
  get isValid() {
    return this.form.controls[this.field.name].valid
  }
  get isDirty() {
    return this.form.controls[this.field.name].dirty
  }
  constructor(private cdr: ChangeDetectorRef) {}
  ngAfterViewInit(): void {
    if (localStorage.getItem('repalert') === 'true') {
      this.reptextval = true
    } else {
      this.reptextval = false
    }
    setTimeout(() => {
      if (
        this.cdr !== null &&
        this.cdr !== undefined &&
        !(this.cdr as ViewRef).destroyed
      ) {
        //  this.cdr.detectChanges()
      }
    }, 250)
  }
}
